import LoadingSpinner, { LoadingSpinnerSize } from '../LoadingSpinner';
import './loadingSpinnerInContainer.less';

type LoadingSpinnerInContainerProps = {
	height?: string | number;
	size?: LoadingSpinnerSize;
};

export default function LoadingSpinnerInContainer({
	height = 'auto',
	size = LoadingSpinnerSize.medium,
}: LoadingSpinnerInContainerProps) {
	return (
		<div
			className="loading-spinner-in-container"
			style={{
				height,
			}}>
			<LoadingSpinner size={size} />
		</div>
	);
}
